module.exports = __webpack_public_path__ + "img/es-ont-en.e9db4a4e.svg";